import React from "react";

import { useForgotFlow } from "src/banking/authentication/ForgotFlow/hooks";
import { handleCurrentState } from "./handleCurrentState";
import forgotUsernameComponents from "./steps";

const ForgotUsername = props => {
  const { forgotFlowState, setForgotFlowState, onSubmit } = useForgotFlow(
    handleCurrentState,
    props
  );

  const Component = forgotUsernameComponents[forgotFlowState.state];

  if (!Component) {
    return null;
  }

  return (
    <Component
      onSubmit={onSubmit}
      forgotFlowState={forgotFlowState}
      setForgotFlowState={setForgotFlowState}
      onCancelRoute={"/app"}
    />
  );
};

export default ForgotUsername;



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotLogin/ForgotUsername/ForgotUsername.js